import { Screen } from '@modules/shared/services/window.service';

import { MediaSetting } from '../media-setting.interface';

export const Hero3SectionImageStyleLarge: MediaSetting[] = [
  { screen: Screen.XXXS, key: '2_1_568', width: 568, height: 284, ratio: 2 },
  { screen: Screen.XS, key: '2_1_768', width: 768, height: 384, ratio: 2 },
  { screen: Screen.SM, key: '2_1_1024', width: 1024, height: 512, ratio: 2 },
  { screen: Screen.MD, key: '2_1_1366', width: 1366, height: 683, ratio: 2 },
  { screen: Screen.LG, key: '3_2_1053', width: 1280, height: 853, ratio: 1.5 },
  { screen: Screen.XL, key: '3_2_1266', width: 1280, height: 853, ratio: 1.5 },
];

export const Hero3SectionImageStyleSmall: MediaSetting[] = [
  { screen: Screen.XXXS, key: '2_1_568', width: 568, height: 284, ratio: 2 },
  { screen: Screen.XS, key: '2_1_768', width: 768, height: 384, ratio: 2 },
  { screen: Screen.SM, key: '3_2_492', width: 500, height: 334, ratio: 1.5 },
  { screen: Screen.MD, key: '3_2_683', width: 720, height: 480, ratio: 1.5 },
  { screen: Screen.LG, key: '3_2_512', width: 540, height: 360, ratio: 1.5 },
  { screen: Screen.XL, key: '3_2_660', width: 720, height: 480, ratio: 1.5 },
];
